import { render, staticRenderFns } from "./TableHeadDataDesignFilter.vue?vue&type=template&id=f52350c0"
import script from "./TableHeadDataDesignFilter.vue?vue&type=script&lang=ts"
export * from "./TableHeadDataDesignFilter.vue?vue&type=script&lang=ts"
import style0 from "./TableHeadDataDesignFilter.vue?vue&type=style&index=0&id=f52350c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports